import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { LoginPage } from '@/features/auth';

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/_public/login/')({
  validateSearch: zodValidator(loginSearchSchema),
  component: LoginIndexRouteComponent,
});

function LoginIndexRouteComponent() {
  const search = Route.useSearch();

  return <LoginPage redirect={search.redirect} />;
}
